import { RefreshCw } from '@/components/common/icons';

export function ManagementDashboardHeader({
  currentUser,
  range,
  rangeOptions,
  onRangeChange,
  customStart,
  onCustomStartChange,
  customEnd,
  onCustomEndChange,
  onRefresh,
  onExport,
  exporting,
  exportingFormat
}) {
  return (
    <div className="page-card__header">
      <div>
        <p className="page-card__eyebrow">Management Analytics</p>
        <h1 className="page-card__title">Management Dashboard</h1>
      </div>

      <div className="dashboard-controls mobile-header-controls">
        <div className="page-card__status">
          {(currentUser?.['Employee Name'] || currentUser?.Name || 'Manager')} {currentUser?.Role ? `| ${currentUser.Role}` : ''}
        </div>
        {range === 'custom' && (
          <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            <label className="dashboard-control" style={{ margin: 0 }}>
              <span style={{ fontSize: '11px', fontWeight: '600', color: '#64748b', display: 'block', marginBottom: '2px' }}>From</span>
              <input 
                type="date" 
                value={customStart} 
                onChange={(e) => onCustomStartChange(e.target.value)} 
                style={{ padding: '6px 10px', borderRadius: '8px', border: '1px solid #cbd5e1', fontSize: '13px', background: '#fff' }}
              />
            </label>
            <label className="dashboard-control" style={{ margin: 0 }}>
              <span style={{ fontSize: '11px', fontWeight: '600', color: '#64748b', display: 'block', marginBottom: '2px' }}>To</span>
              <input 
                type="date" 
                value={customEnd} 
                onChange={(e) => onCustomEndChange(e.target.value)} 
                style={{ padding: '6px 10px', borderRadius: '8px', border: '1px solid #cbd5e1', fontSize: '13px', background: '#fff' }}
              />
            </label>
          </div>
        )}
        <label className="dashboard-control">
          <span>Date Range</span>
          <select value={range} onChange={(event) => onRangeChange(event.target.value)}>
            {rangeOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </label>
        {onExport && (
          <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            <button
              type="button"
              className="attendance-cta attendance-cta--red"
              disabled={Boolean(exporting || exportingFormat)}
              onClick={() => onExport('pdf')}
              style={{ padding: '0 16px', height: '36px', fontSize: '13px' }}
            >
              {exportingFormat === 'pdf' ? 'Exporting...' : 'PDF'}
            </button>
            <button
              type="button"
              className="attendance-cta attendance-cta--green"
              disabled={Boolean(exporting || exportingFormat)}
              onClick={() => onExport('xlsx')}
              style={{ padding: '0 16px', height: '36px', fontSize: '13px' }}
            >
              {exportingFormat === 'xlsx' ? 'Exporting...' : 'Excel'}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
